import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const heightItemRow = heightPercentageToDP(48);

const styles = StyleSheet.create({
    container: {
        alignItems: 'flex-start',
        marginTop: heightPercentageToDP(16),
        height: heightPercentageToDP(40),
        marginHorizontal: widthPercentageToDP(16),
    },
    buttonContainer: {
        borderRadius: 99,
        borderWidth: 1.5,
        borderColor: lightGrey(0.7),
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        paddingHorizontal: widthPercentageToDP(15),
        paddingVertical: heightPercentageToDP(8),
        maxHeight: heightPercentageToDP(40),
    },
    buttonText: {
        fontSize: 16,
        fontFamily: Fonts.main.bold,
        fontStyle: 'normal',
        color: COLOR.highContrast,
        lineHeight: 24,
    },
    listItemContainer: {
        height: heightItemRow,
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: widthPercentageToDP(16),
    },
    listItemContainerSelected: {
        backgroundColor: COLOR.primary,
    },
    listItemText: {
        marginHorizontal: widthPercentageToDP(16),
        fontSize: 16,
        opacity: 0.5,
        fontFamily: Fonts.main.regular,
        color: COLOR.highContrast,
    },
    listItemTextSelected: {
        fontFamily: Fonts.main.bold,
        opacity: 1,
        color: COLOR.BLACK,
    },
    safeArea: {
        flex: 1,
        marginHorizontal: widthPercentageToDP(0, 160),
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    scroll: {
        flex: 1,
        paddingBottom: heightPercentageToDP(24),
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    bottomSheetBackgroundStyle: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    arrowDown: {
        width: undefined,
        marginLeft: widthPercentageToDP(15),
    },
    arrowDownSvg: {
        width: widthPercentageToDP(12),
        height: heightPercentageToDP(6),
    },
});

export default styles;
